import React from 'react';
import publicHomepageContent from '../../content/publicHomepageContent';

void React;
const KRINKELS_LOGO_SRC = '/Krinkels-logo.png';

export default function RobotContactBanner() {
  // keep publicHomepageContent available for potential future copy changes
  void publicHomepageContent;
  void KRINKELS_LOGO_SRC;
  return (
    <section className="kr-section kr-contact-banner" aria-labelledby="contact-banner-heading">
      <div className="kr-shell kr-contact-shell">
        <div className="kr-contact-inner kr-contact-grid">
          <div className="kr-contact-left">
            <h2 id="contact-banner-heading" className="kr-contact-title">Meer weten over robotmaaien?</h2>
            <p className="kr-contact-subtext">Krinkels adviseert over de inzet van robotmaaiers en over installatie, inrichting en beheer in de praktijk.</p>
          </div>
          <div className="kr-contact-right">
            <div className="kr-contact-right-intro"><strong>Samen aanpakken</strong></div>
            <p className="kr-contact-right-text">Neem contact op voor de mogelijkheden en technische randvoorwaarden.</p>
            <div className="kr-contact-actions">
              <a href="/tickets" className="kr-btn kr-btn-brandbook kr-contact-ticket-link">Ticket aanmaken<span className="kr-btn-icon-box" aria-hidden><svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 12h14M13 5l7 7-7 7" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg></span></a>
              <a href="https://krinkels.nl/contact/" target="_blank" rel="noopener noreferrer" className="kr-btn kr-btn-brandbook">Contact<span className="kr-btn-icon-box" aria-hidden><svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 12h14M13 5l7 7-7 7" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg></span></a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
